import React, { useState, useEffect } from "react";
import { ReactComponent as Conversation } from "../../assets/Conversation.svg";
import { USER_GUIDE_BETA_ENG, PRIVACY_POLICY } from "../../constants/urls";
import { FrButton, FrFinePrint } from "../../components/DesignSystem/style";
import styled from "styled-components";
import { smoothIn } from "../../styles/keyframes";

const UserGuide = () => {
  const [firstVisit, setFirstVisit] = useState(false);
  useEffect(() => {
    const hasVisited = JSON.parse(window.localStorage.getItem("hasVisited"));
    if (!hasVisited) {
      setFirstVisit(true);
    }
  }, []);

  const onClick = () => {
    window.localStorage.setItem("hasVisited", JSON.stringify("true"));
    setFirstVisit(false);
  };

  return (
    <>
      {firstVisit && (
        <PopupContainer>
          <GuidePopupWrapper>
            <Conversation />
            <p>Thanks for joining the Fictive Beta! We strongly recommend reading our guide before continuing.</p>
            <div>
              <a href={USER_GUIDE_BETA_ENG} target="_blank" rel="noopener noreferrer">
                Open guide
              </a>
              <button onClick={() => onClick()}>Continue</button>
            </div>
          </GuidePopupWrapper>
        </PopupContainer>
      )}
    </>
  );
};

export default UserGuide;

export const PrivacyPolicy = ({ authUser, firebase, navigate, dispatch }) => {
  const saveConsent = () => {
    firebase.updateUser(authUser.userId, { termsConsent: true });
    authUser.termsConsent = true;
    if (dispatch) dispatch({ type: "SET_USER", user: authUser });
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <PopupContainer>
      <GuidePopupWrapper style={{ minWidth: "300px", minHeight: "300px" }}>
        <h2>Privacy Notice</h2>
        <p>
          I consent to essential cookies{authUser && authUser.email && ", receiving service email"} and sharing my
          recordings when talking to the AI.
          <br />
          <a href={PRIVACY_POLICY} target="_blank" rel="noopener noreferrer">
            Read our privacy policy for details!
          </a>
        </p>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <FrButton
            style={{ background: "var(--key-color-2)" }}
            onClick={() => {
              saveConsent();
            }}
          >
            Accept
          </FrButton>
          <FrButton
            onClick={() => {
              firebase.signOut(navigate);
            }}
          >
            Decline
          </FrButton>
        </div>
        <FrFinePrint>Declining will sign you out of the app.</FrFinePrint>
      </GuidePopupWrapper>
    </PopupContainer>
  );
};

export const PopupContainer = styled.div`
  width: 100%;
  height: 100vh;
  background: rgb(102 102 102 / 70%);
  position: fixed;
  top: 0;
  right: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  animation: ${smoothIn} 0.4s;
`;

export const GuidePopupWrapper = styled.div`
  width: 50%;
  min-width: 300px;
  max-width: 600px;
  padding: 20px 30px;
  border-radius: 20px;
  background: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;

  svg {
    width: 200px;
    height: auto;
  }

  h5 {
    font-size: 14px;
    color: var(--grey-1);
  }

  p {
    padding: 20px 0;
    line-height: 1.4;
    text-align: center;
  }

  div {
    a {
      margin: 10px;
      background: var(--key-color-2-gradient);
      color: white;
      padding: 8px 30px;
      border-radius: 20px;
      font-weight: 600;
      cursor: pointer;
      font-size: 16px;
      &:hover {
        box-shadow: "0px 0px 5px var(--key-color-2)";
      }
    }

    button {
      margin: 0 5px;
      background: var(--grey-3);
      color: white;
      padding: 8px 30px;
      border-radius: 20px;
      font-weight: 600;
      cursor: pointer;
      border: none;
      outline: none;
      font-size: 16px;

      &:hover {
        box-shadow: "0px 0px 5px var(--key-color-2)";
      }
    }

    @media (max-width: 768px) {
      display: flex;
      flex-direction: column;
    }
  }
`;
